// Foto ridotta a 1600 px in JPEG prima di mandarla: non si salva da nessuna parte
export const fotoCompressa = (file, lato = 1600) => new Promise((ok, ko) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    const k = Math.min(1, lato / Math.max(img.width, img.height));
    const c = document.createElement('canvas');
    c.width = Math.round(img.width * k);
    c.height = Math.round(img.height * k);
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    URL.revokeObjectURL(url);
    ok(c.toDataURL('image/jpeg', 0.85));
  };
  img.onerror = () => { URL.revokeObjectURL(url); ko(new Error('Foto non leggibile')); };
  img.src = url;
});
